import styled, { Link } from 'easyguide'
import downloadIcon from 'assets/download-icon.svg'

export const DownloadIcon = styled.span`
  margin-right: 7px;
  :before {
    display: block;
    height: 13px;
    width: 13px;
    background-size: 13px 13px;
    content: '';
    background-image: url(${downloadIcon});
  }
`

export const StyledLink = styled(Link)`
  display: flex;
  cursor: pointer;
`
